import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const Verification = lazy(() => import('../../pages/Verification/VerificationPage'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="/*" element={<Verification />} />
    </Routes>
  );
}

export default PagesRoute;
